import React from 'react';
import Button from './Button';
import useTags from '../../hooks/useTags';
import buttonLang from '../../data/lang/button.lang';


type TypeSendFormBtm = {
    onClick: () => void;
    show: boolean;
    isLoading?: boolean;
    btnLabel?: string;
    disabled?: boolean;
}

const SendFormBtm = ({ onClick, show, isLoading = false, btnLabel = '', disabled = false }: TypeSendFormBtm) => {

    const generateTag = useTags();
    const defualtLabel = generateTag(buttonLang, 'send-form');

    if (!show) return null;

    return (
        <Button theme='success'
            onClick={onClick}
            text={btnLabel || defualtLabel}
            disabled={disabled}
            isLoading={isLoading}
        />
    );
}

export default SendFormBtm;